import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, login as apiLogin, logout as apiLogout } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = unknown, false = guest, object = admin
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const token = localStorage.getItem("reness_admin_token");
      if (!token) {
        setUser(false);
        setLoading(false);
        return;
      }
      try {
        const me = await fetchMe();
        setUser(me);
      } catch {
        localStorage.removeItem("reness_admin_token");
        setUser(false);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const signIn = async (email, password) => {
    const data = await apiLogin(email, password);
    localStorage.setItem("reness_admin_token", data.access_token);
    setUser(data.user);
    return data.user;
  };

  const signOut = async () => {
    try { await apiLogout(); } catch (_) { /* noop */ }
    localStorage.removeItem("reness_admin_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export default AuthContext;
